import React from 'react'
import CheckEmail from '../../../Components/Molecules/ForgotPassword/CheckEmail'

function CheckEmailTemplate() {
  return (
    <CheckEmail />
  )
}

export default CheckEmailTemplate